import type { FileResponseV2 } from '@emma/api_client/types';
import { deploymentFileTable } from '../common/table/column_definitions/DeploymentFile';
import { TableStoreProvider } from '../common/table/store/Context';
import { Table } from '../common/table/Table';
import { FileContent } from '../file/FileContent';

type Props = {
  files: FileResponseV2[];
  workspaceId: number;
};

const deploymentFilesDescription =
  'Files included in this deployment that are distributed to devices. Click a row to view its contents';

export const DeploymentFileTable = (props: Props) => {
  return (
    <TableStoreProvider initialSorting={[{ desc: true, id: 'id' }]} name="DeploymentFiles">
      <Table
        columns={deploymentFileTable}
        data={props.files || []}
        description={deploymentFilesDescription}
        expandableRow={(row) => (
          <FileContent fileId={row.original.id} workspaceId={props.workspaceId} />
        )}
        onRowClick={(_, row) => row.getToggleExpandedHandler()}
        title="Files"
      />
    </TableStoreProvider>
  );
};
